module.exports = __webpack_public_path__ + "static/media/KW.5a962270.svg";